import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Resolve, RouterStateSnapshot,
  ActivatedRouteSnapshot } from '@angular/router';

import { Video } from '../../classes/video';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable()
export class VideoBookResolver implements Resolve<Object> {

  private apiKey = 'AIzaSyA6QHIUa2MrIBDqTxRNOn8Ozw5Ol7UAv7Y';
  constructor(private router: Router, private http: HttpClient) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Object> {
    const name = route.paramMap.get('bookName');
    let playlistId: string;

    switch (name) {
      case 'music':
        playlistId = 'UU91zvxtvEPZ2oE9ZEh2TNaQ';
        break;
      case 'fairyfinds':
        playlistId = 'UU91zvxtvEPZ2oE9ZEh2TNaQ';
        break;
      case 'stories':
        playlistId = 'UU91zvxtvEPZ2oE9ZEh2TNaQ';
        break;
      default:
        this.router.navigate(['/videos']);
        return null;
    }

    const videoData = this.http.get(
      'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=10&playlistId=' + playlistId
      + '&key=' + this.apiKey);

    return videoData;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/video-book/video-book-resolver.ts